import styles from "./styles";
import { useState, useEffect } from "react";
import { DivTablePage } from "../../components/common/DivTablePage";
import { useTripsContext } from "../../context";
import classVeryTable from "../../components/common/v2/VeryTable/classVeryTable";
import { VeryTable } from "../../components/common/v2/VeryTable";
import { CellTooltip } from "../../components/common/v2/VeryTable/CellTooltip";
import StylesCellTooltip from "../../components/common/v2/VeryTable/CellTooltip/styles";
import {
  getFormattedNumber,
  getMomentES,
  getNotNegativeNumber,
  isStringEmpty,
} from "../../utils/handler_validations";
import { VeryIconGoogle } from "../../components/common/v2/VeryIconGoogle";
import RatePreviewChart from "../../components/common/RatePreviewChart";
import { classVeryIconGoogle } from "../../components/common/v2/VeryIconGoogle/classVeryIconGoogle";
import { ColRoute } from "../../components/drivers-page/ColRoute";
import { DispatchAuditPanel } from "../../components/trips/DispatchAuditPanel";
import { TripRouteLogPanel } from "../../components/trips/TripRouteLogPanel";

export const ContentTripsPage = (props) => {
  const trips = useTripsContext();
  const [auditTripId, setAuditTripId] = useState(0);
  const [routeLogTrip, setRouteLogTrip] = useState(null);

  return (
    <>
      <styles.DivMain
        isLoading={trips.value.page.loading}
        error={trips.value.page.error}
        onClickBtnRetry={() => trips.getListInitial()}
      >
        <DivTablePage emptyMessage={trips.getEmptyMsgPage()}>
          <VeryTable
            CSS={["tripsTable"]}
            rows={trips.value.list}
            getRowId={(row) => row.rowId}
            disabledRowSelection={false}
            rowSelected={trips.selectedRow}
            onChangeRowSelected={(rowId) => trips.onChangeSelectedRow(rowId)}
            columns={{
              // column profile passenger
              col_passenger: classVeryTable.getColumnTemplate(
                "Pasajero",
                "Nombre del pasajero",
                2,
                150,
                130,
                true,
                true,
                (params) => {
                  return trips.getPassengerName(params.row.trip?.passengerId);
                },
                (params) => {
                  return classVeryTable.renderColProfile(
                    trips.getProfileImgUser(params.row.trip?.passengerId),
                    params.value,
                  );
                },
              ),
              // column profile driver
              col_driver: classVeryTable.getColumnTemplate(
                "Conductor",
                "Nombre del conductor",
                2,
                150,
                130,
                true,
                true,
                (params) => {
                  return trips.getDriverName(
                    params.row.trip?.driverId,
                    params.row.trip?.status,
                  );
                },
                (params) => {
                  return classVeryTable.renderColProfile(
                    trips.getProfileImgDriver(params.row.trip?.driverId),
                    params.value,
                  );
                },
              ),
              // column distance trip
              col_distance: classVeryTable.getColumnTemplate(
                "Distancia",
                "Distance del origen al destino del viaje",
                0,
                100,
                80,
                true,
                true,
                (params) => {
                  return params.row.trip?.distance;
                },
                (params) => {
                  const formattedDistance = getFormattedNumber(
                    params.value,
                    true,
                    1,
                  );
                  return (
                    <CellTooltip
                      divCellCSS={["cellDistance"]}
                      contentCell={
                        <StylesCellTooltip.LabelCell>
                          {formattedDistance} km
                        </StylesCellTooltip.LabelCell>
                      }
                      contentTooltip={
                        <StylesCellTooltip.LabelTooltip>
                          {formattedDistance} km
                        </StylesCellTooltip.LabelTooltip>
                      }
                    />
                  );
                },
              ),
              // column cost trip
              col_cost: classVeryTable.getColumnTemplate(
                "Ingreso",
                "Costo del viaje",
                0,
                100,
                80,
                true,
                true,
                (params) => {
                  return params.row.trip?.cost;
                },
                (params) => {
                  const formattedCost = getFormattedNumber(
                    params.value,
                    true,
                    2,
                  );
                  const existCoupon = !isStringEmpty(params.row.coupon?.code);
                  const amountCoupon = getNotNegativeNumber(
                    params.row.coupon?.amount,
                  );
                  const formattedAmount = getFormattedNumber(
                    amountCoupon > params.value ? params.value : amountCoupon,
                    true,
                    2,
                  );

                  const estimateGeneralCost = (distanceKm) => {
                    const totalInc = distanceKm / 3;
                    const incBase = Math.floor(totalInc);
                    let increments = incBase;
                    let diff = Math.abs(totalInc - incBase);
                    const diffM = Math.abs(totalInc - (incBase + 0.5));
                    const diffS = Math.abs(totalInc - (incBase + 1));
                    if (diffM <= diff) {
                      diff = diffM;
                      increments = incBase + 0.5;
                    }
                    if (diffS <= diff) increments = incBase + 1;
                    return 45 + increments * 10;
                  };

                  let snapshot = params.row.trip?.appliedRateSnapshot;
                  if (!snapshot) {
                    const distance = getNotNegativeNumber(params.row.trip?.distance);
                    const cost = getNotNegativeNumber(params.row.trip?.cost);
                    const estGeneral = estimateGeneralCost(distance);
                    const diff = Math.round(cost - estGeneral);
                    const guessedNight = (diff === 10 || diff === 20) ? diff : 0;
                    snapshot = {
                      rateName: "Tarifa General",
                      initialRate: 45,
                      kilometers: 3,
                      isDynamic: true,
                      pricePerKilometer: 10,
                      nightIncrement: guessedNight,
                    };
                  }
                  const hasSnapshot = true;

                  return (
                    <CellTooltip
                      divMainCSS={["cellCost"]}
                      divCellCSS={["cell-content"]}
                      contentCell={
                        <>
                          <StylesCellTooltip.LabelCell>
                            ${formattedCost}
                          </StylesCellTooltip.LabelCell>
                          <VeryIconGoogle
                            name="confirmation_number"
                            type={classVeryIconGoogle.ICON_TYPE.FILLED}
                            size={13}
                            color={
                              existCoupon
                                ? classVeryIconGoogle.ICON_COLOR.GREEN_S2
                                : classVeryIconGoogle.ICON_COLOR.GRAY_S2
                            }
                          />
                        </>
                      }
                      contentTooltip={
                        <div className="div-contentTooltip">
                          <label className="txt-light">
                            {"Costo del viaje: "}
                            <label className="txt-bold">${formattedCost}</label>
                          </label>
                          {existCoupon && (
                            <>
                              <label className="txt-light">
                                {"Nombre del cupón: "}
                                <label className="txt-bold">
                                  {params.row.coupon.code}
                                </label>
                              </label>
                              <label className="txt-light">
                                {"Descuento: "}
                                <label className="txt-bold txt-amount">
                                  -${formattedAmount}
                                </label>
                              </label>
                            </>
                          )}
                          <hr
                            style={{
                              margin: "4px 0",
                              border: "none",
                              borderTop: "1px solid #e5e7eb",
                            }}
                          />
                          {hasSnapshot ? (
                            <>
                              <label className="txt-light">
                                {"Tarifa aplicada: "}
                                <label className="txt-bold">
                                  {snapshot.rateName}
                                </label>
                              </label>
                              <label className="txt-light">
                                {"Tarifa base: "}
                                <label className="txt-bold">
                                  ${snapshot.initialRate ?? "—"} /{" "}
                                  {snapshot.kilometers ?? 1} km
                                </label>
                              </label>
                              {snapshot.isDynamic && (
                                <label className="txt-light">
                                  {"Precio extra: "}
                                  <label className="txt-bold">
                                    ${snapshot.pricePerKilometer ?? "—"} / km
                                    adicional
                                  </label>
                                </label>
                              )}
                              {snapshot.nightIncrement > 0 && (
                                <label className="txt-light">
                                  {snapshot.nightIncrement === 10
                                    ? "Horario nocturno 1: "
                                    : snapshot.nightIncrement === 20
                                    ? "Horario nocturno 2: "
                                    : "Incremento nocturno: "}
                                  <label className="txt-bold" style={{ color: "#F7AF36" }}>
                                    +${getFormattedNumber(snapshot.nightIncrement, true, 2)}
                                  </label>
                                </label>
                              )}
                              <RatePreviewChart
                                initialRate={snapshot.initialRate}
                                kilometers={snapshot.kilometers}
                                pricePerKilometer={snapshot.pricePerKilometer}
                                isDynamic={snapshot.isDynamic}
                                priceOnDemand={
                                  snapshot.isDemand ? snapshot.priceOnDemand : 0
                                }
                                highlightKm={params.row.trip?.distance}
                                actualCost={params.row.trip?.cost}
                                width={220}
                                height={80}
                              />
                            </>
                          ) : (
                            <label className="txt-light txt-no-rate">
                              Sin tarifa dinámica registrada
                            </label>
                          )}
                        </div>
                      }
                    />
                  );
                },
              ),
              // column status trip
              col_status: classVeryTable.getColumnTemplate(
                "Estatus",
                "Estatus del viaje",
                2,
                120,
                100,
                true,
                true,
                (params) => {
                  return trips.getFormattedStatusTrip(params.row.trip?.status);
                },
                (params) => {
                  const cellCSS = ["txtStatus"];
                  const status = trips.getStatusTrip(params.row.trip?.status);
                  if (!isStringEmpty(status)) cellCSS.push(status);
                  return (
                    <CellTooltip
                      divCellCSS={["cellStatus"]}
                      contentCell={
                        <div className={cellCSS.join(" ")}>{params.value}</div>
                      }
                      contentTooltip={
                        <StylesCellTooltip.LabelTooltip>
                          {params.value}
                        </StylesCellTooltip.LabelTooltip>
                      }
                    />
                  );
                },
              ),
              // column request date trip
              col_date: classVeryTable.getColumnTemplate(
                "Fecha y hora",
                "Fecha de solicitud del viaje",
                0,
                220,
                200,
                true,
                true,
                (params) => {
                  const formattedDate = trips.getRequestDateTrip(
                    params.row.trip?.requestDate,
                  );
                  return `${formattedDate.date}, ${formattedDate.time}`;
                },
                (params) => {
                  const formattedDate = trips.getRequestDateTrip(
                    params.row.trip?.requestDate,
                  );
                  return (
                    <CellTooltip
                      divCellCSS={["cellDate"]}
                      contentCell={
                        <label className="txt-fullDate">
                          <label className="txt-date">
                            {formattedDate.date},
                          </label>
                          {` ${formattedDate.time}`}
                        </label>
                      }
                      contentTooltip={
                        <StylesCellTooltip.LabelTooltip>
                          {`${formattedDate.date}, ${formattedDate.time}`}
                        </StylesCellTooltip.LabelTooltip>
                      }
                    />
                  );
                },
              ),
              // column btn route (origin/dest and route logs unified)
              col_route: classVeryTable.getColumnTemplate(
                "Ruta",
                "Ver ubicación, direcciones y logs de ruta del viaje",
                0,
                75,
                60,
                true,
                false,
                undefined,
                (params) => {
                  const tripId = params.row.trip?.id;
                  const passengerName = trips.getPassengerName(params.row.trip?.passengerId);
                  const driverName = trips.getDriverName(params.row.trip?.driverId, params.row.trip?.status);
                  return (
                    <StylesCellTooltip.DivCell className="cellRoute" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: tripId > 0 ? "pointer" : "default",
                          opacity: tripId > 0 ? 1 : 0.3,
                          padding: "4px",
                          borderRadius: "6px",
                          transition: "background 0.15s",
                        }}
                        title="Ver detalles de ruta y direcciones"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (tripId > 0) {
                            trips.onChangeSelectedRow(params.row.rowId);
                            setRouteLogTrip({ tripId, passengerName, driverName, rowId: params.row.rowId });
                          }
                        }}
                      >
                        <VeryIconGoogle
                          CSS={[]}
                          type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                          name="map"
                          size={22}
                          color={
                            routeLogTrip?.tripId === tripId
                              ? classVeryIconGoogle.ICON_COLOR.BLACK_S1
                              : classVeryIconGoogle.ICON_COLOR.GRAY_S3
                          }
                        />
                      </div>
                    </StylesCellTooltip.DivCell>
                  );
                },
              ),
              // column btn dispatch audit
              col_audit: classVeryTable.getColumnTemplate(
                "Asignación",
                "Ver registro de conductores notificados al solicitar el viaje",
                0,
                90,
                80,
                true,
                false,
                undefined,
                (params) => {
                  const tripId = params.row.trip?.id;
                  return (
                    <StylesCellTooltip.DivCell className="cellRoute">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: tripId > 0 ? "pointer" : "default",
                          opacity: tripId > 0 ? 1 : 0.3,
                          padding: "4px",
                          borderRadius: "6px",
                          transition: "background 0.15s",
                        }}
                        title="Ver registro de asignación (Log)"
                        onClick={() => tripId > 0 && setAuditTripId(tripId)}
                      >
                        <VeryIconGoogle
                          CSS={[]}
                          type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                          name="manage_search"
                          size={22}
                          color={
                            auditTripId === tripId
                              ? classVeryIconGoogle.ICON_COLOR.BLACK_S1
                              : classVeryIconGoogle.ICON_COLOR.GRAY_S3
                          }
                        />
                      </div>
                    </StylesCellTooltip.DivCell>
                  );
                },
              ),
            }}
          />
        </DivTablePage>
      </styles.DivMain>
      <DispatchAuditPanel
        tripId={auditTripId}
        onClose={() => setAuditTripId(0)}
      />
      <TripRouteLogPanel
        tripId={routeLogTrip?.tripId || 0}
        passengerName={routeLogTrip?.passengerName || ""}
        driverName={routeLogTrip?.driverName || ""}
        rowId={routeLogTrip?.rowId ?? -1}
        onClose={() => setRouteLogTrip(null)}
      />
    </>
  );
};
